"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormLabel = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../theme/utils/useTheme");
var _visuallyhidden = require("../visuallyhidden");
var _FormLabelChild = require("./styled/FormLabelChild");
var _FormLabelContentAfter = require("./styled/FormLabelContentAfter");
var _FormLabelDescription = require("./styled/FormLabelDescription");
var _FormLabelFeedback = require("./styled/FormLabelFeedback");
var _FormLabelIcon = require("./styled/FormLabelIcon");
var _FormLabelLabel = require("./styled/FormLabelLabel");
var _FormLabelStyled = require("./styled/FormLabelStyled");
var _FormLabelValidation = require("./styled/FormLabelValidation");
var _formLabelColorTheme = require("./styled/formLabelColorTheme");
var _formLabelIcons = require("./styled/formLabelIcons");
const FormLabel = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    id,
    label: labelText,
    labelProps: providedLabelProps,
    description,
    descriptionProps: providedDescriptionProps,
    validationRootProps,
    hideLabel,
    validationState,
    validationProps: providedValidationProps,
    validationMessage,
    icon,
    clientId,
    contentAfter,
    "aria-describedby": ariaDescribedBy,
    ...rest
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const childId = (0, _react.useMemo)(() => id ?? (0, _lodestarUtils.genId)("fl-input"), [id]);
  const providedLabelId = providedLabelProps?.id;
  const labelId = (0, _react.useMemo)(() => providedLabelId ?? (0, _lodestarUtils.genId)("fl-label"), [providedLabelId]);
  const finalLabelProps = {
    htmlFor: childId,
    ...providedLabelProps,
    id: labelId,
    validationState: validationState ?? "info"
  };
  const providedDescriptionId = providedDescriptionProps?.id;
  const descId = (0, _react.useMemo)(() => providedDescriptionId ?? (0, _lodestarUtils.genId)("fl-desc"), [providedDescriptionId]);
  const finalDescriptionProps = {
    ...providedDescriptionProps,
    tooltipPlacement: providedDescriptionProps?.tooltipPlacement ?? "bottom",
    id: descId
  };
  const childProps = {
    id: childId,
    "aria-labelledby": labelId,
    ...(description && {
      "aria-describedby": `${descId} ${ariaDescribedBy ?? ""}`.trim()
    })
  };
  const label = /*#__PURE__*/_react.default.createElement(_FormLabelLabel.FormLabelLabel, (0, _extends2.default)({
    renderAs: "label"
  }, finalLabelProps, _FormLabelLabel.labelVariantProps[themeMode], {
    themeMode: themeMode
  }), labelText, contentAfter && /*#__PURE__*/_react.default.createElement(_FormLabelContentAfter.FormLabelContentAfter, null, contentAfter) || null);
  return /*#__PURE__*/_react.default.createElement(_FormLabelStyled.FormLabelStyled, (0, _extends2.default)({
    "data-client-id": clientId,
    ref: ref
  }, rest), hideLabel ? /*#__PURE__*/_react.default.createElement(_visuallyhidden.VisuallyHidden, null, label) : label, /*#__PURE__*/_react.default.createElement(_FormLabelDescription.FormLabelDescription, (0, _extends2.default)({}, finalDescriptionProps, _formLabelColorTheme.descriptionVariantProps[themeMode], {
    themeMode: themeMode
  }), description), /*#__PURE__*/_react.default.createElement(_FormLabelChild.FormLabelChild, null, children(childProps)), /*#__PURE__*/_react.default.createElement(_FormLabelFeedback.FormLabelFeedback, (0, _extends2.default)({
    orientation: "row",
    space: "xxSmall",
    "aria-live": "assertive",
    themeMode: themeMode,
    role: "alert",
    "aria-busy": validationState === "waiting"
  }, validationRootProps), validationMessage && validationState && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FormLabelIcon.FormLabelIcon, {
    validationState: validationState || "info",
    themeMode: themeMode
  }, icon ?? (0, _formLabelIcons.iconBasedOnValidationState)(validationState, themeMode)), /*#__PURE__*/_react.default.createElement(_FormLabelValidation.FormLabelValidation, (0, _extends2.default)({
    validationState: validationState
  }, providedValidationProps, _formLabelColorTheme.descriptionVariantProps[themeMode], {
    themeMode: themeMode
  }), validationMessage))));
});
exports.FormLabel = FormLabel;
FormLabel.displayName = "FormLabel";
//# sourceMappingURL=FormLabel.js.map